<div class="menu-details-tarifications">
    <ng-container *ngIf="hasRetailInPayload">
        <ng-container *ngFor="let item of itemsTarifications">
            <a *ngIf="item.exist"
               class="tab"
               [style.minWidth]="item.minWidth"
               [ngClass]="{ 'selected': item.selected }"
               (click)="changeTab(item.code)">{{ item.name }}</a>
        </ng-container>
    </ng-container>

    <btn class="toggle-details-link btn-right-align"
         (click)="toggleDetails()"
         [label]="labelToShow"
         type="actionHeaderLink">
    </btn>
</div>